import { createSelector } from 'reselect'

import confirmTypes from 'helpers/enums/confirmTypes'
import studentSlideTimerSelector from 'redux/selectors/student/timer'
import sizeSelector from 'redux/selectors/ui/sizeSelector'
import { sessionTypesWithNoSubmit, sessionTypesWithSubmitDisabled } from 'helpers/session/submitOptions'

import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.TIMER_POLL_QUIZ_OEQ,
	featureFlagsTypes.STUDENT_RECORDING_AUDIO_OEQ,
])

const getStudentViewData = state => state.student
const getConfirmsData = state => state.confirm
const getSlideId = (state, props) => props.session.session_uid + '_' + props.slide.slideId

const getConfirmTexts = function() {
	return null
}

const getConfirmType = function(confirms) {
	const confirmsArray = [
		confirmTypes.STUDENT_SUBMIT_DRAWIT_CONFIRMED,
		confirmTypes.STUDENT_SUBMIT_FAILED_CONFIRM,
		confirmTypes.STUDENT_SUBMIT_DRAWIT_REQUIRED,
	]
	if (confirms && confirms.length && confirmsArray.includes(confirms[0].confirmType)) {
		return confirms[0].confirmType
	} else {
		return null
	}
}

const getConfirm = function(confirms) {
	const confirmType = getConfirmType(confirms)
	if (confirmType) {
		return {
			type: confirmType,
			...getConfirmTexts(confirmType),
		}
	} else {
		return null
	}
}

const getStudentSlideData = createSelector(
	[ getStudentViewData, getConfirmsData, studentSlideTimerSelector, getSlideId, featureFlagsSelector, sizeSelector ],
	(student, confirms, timer, slideId, featureFlags, size) => {
		const slide_data = student.slides[slideId]
		let isImmersiveReaderEnabled = false
		let shouldDisableGoogleImages = false
		let hasTitle = false

		if (slide_data) {
			isImmersiveReaderEnabled = slide_data.shouldShowImmersiveReader
			hasTitle = slide_data.title.trim() !== ''
			shouldDisableGoogleImages = slide_data.shouldDisableGoogleImages
		}

		return {
			slide_data,
			confirm: getConfirm(confirms),
			timer,
			size,
			isSubmitHidden: sessionTypesWithNoSubmit.includes(student.sessionType),
			isSubmitDisabled: sessionTypesWithSubmitDisabled.includes(student.sessionType),
			shouldShowImmersiveReader:
				isImmersiveReaderEnabled
				&& hasTitle,
			shouldDisableGoogleImages,
		}
	}
)

export default getStudentSlideData
